import { Component, OnInit } from '@angular/core';
import { Member } from 'src/app/interfaces/member';
import { initFlowbite } from 'flowbite';
import { Playbook } from 'src/app/interfaces/playbook';
import { ApiService, MemberRoutineAction, MemberRoutines } from 'src/app/services/api.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { NgModel } from '@angular/forms';
import * as $ from 'jquery'
import { AuthService } from '../auth.service';
import { AppComponent } from 'src/app/app.component';




@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrl: './members.component.css'
})
export class MembersComponent implements OnInit {
  members: Member[] = [];
  membersSource: Member[] = [];
  memberForEdit: Member | undefined;
  memberForRemove: Member | undefined;

  // Rutinas personales del member que se va a quitar: qué hacer con cada una.
  // 'account' (por defecto), 'delete' o 'ws:<workspaceId>'. Lo que no se
  // elija lo pasa el backend a la cuenta, en pausa.
  removeRoutines: MemberRoutines | null = null;
  removeRoutinesLoading = false;
  removeRoutinesUnknown = false;
  removeRoutineChoices: Record<string, string> = {};
  removeWorkspaces: Array<{ id: string; name: string }> = [];

  companySelected: string = "";
  companies: string[] = [];

  txtSendInvite = 'Send Invite';
  
  get dynamicButtonText(): string {
    // Si está en proceso, mostrar el estado correspondiente
    if (this.txtSendInvite === 'Sending...' || this.txtSendInvite === 'Creating...') {
      return this.txtSendInvite;
    }
    // Si no está en proceso, mostrar el texto según el estado del email
    return this.send_email ? 'Create & Send Invite' : 'Create Member';
  }
  txtUpdateMember = "Save changes"
  txtNotificationSuccessTitle="Successfully saved!"
  txtNotificationSuccessMessage="Member updated successfully"
  txtNotificationErrorTitle="There was an error"
  txtNotificationErrorMessage="We were unable to update the member."
  txtMemberNameToRemove=""

  showInviteModal = false;
  showEditMemberModal = false;
  shownotificationSuccess = false;
  shownotificationError = false;
  shownotificationForRemove = false;

  listOfPlaybooks: Playbook[] = [];
  playbooksSource: Playbook[] = [];
  domain: string | undefined = "";


  //FORM NEW MEMBERS
    name: string = '';
    email: string = '';
    job_title: string = '';
    can_edit: boolean = false;
    can_use_advanced_editor: boolean = false;
    can_access_crm: boolean = false;
    can_view_billable_minutes: boolean = false;
    playbooks: string[] = [];
    can_view_recordings: boolean = true;
    can_manage_tokens: boolean = false;
    send_email: boolean = true;

  //FORM FOR EDIT MEMBER
    nameEdit: string = '';
    emailEdit: string = '';
    job_titleEdit: string = '';
    can_editEdit: boolean = false;
    can_use_advanced_editorEdit: boolean = false;
    can_access_crmEdit: boolean = false;
    can_view_billable_minutesEdit: boolean = false;
    can_manage_tokensEdit: boolean = false;
    playbooksEdit: string[] = [];

  // Users management
  users: any[] = [];
  usersSource: any[] = []; // Original unfiltered list
  
  // CRM access management
  currentUserCanAccessCrm: boolean = false;
  showChangePasswordModal = false;
  selectedMember: any = null;
  newPassword: string = '';
  showPasswordError = false;
  passwordErrorMessage = '';

  // Account roles -----------------------------------------------------
  // The signed-in user's own standing in the account: the owner, a
  // promoted admin, or a plain member (plain members never reach this
  // page thanks to the route guard, but we default safely anyway).
  currentUserAccountRole: 'owner' | 'admin' | 'member' = 'member';
  role: 'member' | 'admin' = 'member';        // invite form
  roleEdit: 'member' | 'admin' = 'member';    // edit form

  openActionsMenuId: string | undefined = undefined;

  showChangeEmailModal = false;
  memberForEmailChange: Member | undefined;
  newMemberEmail = '';
  emailChangeError = '';
  emailChangeSaving = false;

  resendingInviteFor: string | undefined = undefined;

  get isOwner(): boolean {
    return this.currentUserAccountRole === 'owner';
  }

  isSelf(member: Member): boolean {
    const myEmail = this.authService.getUserEmail();
    return !!myEmail && !!member.email && myEmail.toLowerCase() === member.email.toLowerCase();
  }

  // Sorting and filtering
  userSortField: string = 'created_time';
  userSortDirection: 'asc' | 'desc' = 'desc';
  userStatusFilter: 'all' | 'active' | 'disabled' = 'all';
  userSearchQuery: string = '';

  constructor(private apiService: ApiService,  private authService: AuthService, private appComponent: AppComponent, private trackingService: TrackingService) {
    this.domain = this.authService.getDomain()
  }

  async ngOnInit(): Promise<void> {
    // Check if current user can access CRM + resolve their own account role
    try {
      const userData = await this.authService.getUserData();
      if (userData) {
        const idTokenResult = await userData.getIdTokenResult(true);
        this.currentUserCanAccessCrm = idTokenResult.claims['can_access_crm'] === true;

        if (idTokenResult.claims['role'] === 'user') {
          this.currentUserAccountRole = 'owner';
        } else if (idTokenResult.claims['account_role'] === 'admin') {
          this.currentUserAccountRole = 'admin';
        } else {
          this.currentUserAccountRole = 'member';
        }

        console.log('🔐 MembersComponent: CRM access check:', {
          email: userData.email,
          can_access_crm: idTokenResult.claims['can_access_crm'],
          hasAccess: this.currentUserCanAccessCrm,
          accountRole: this.currentUserAccountRole
        });
      }
    } catch (error) {
      console.error('Error checking CRM access:', error);
      this.currentUserCanAccessCrm = false;
    }
    
    const playbooksData = await this.apiService.getPlaybooks(false);
    //SORT BY COMPANI
    this.listOfPlaybooks = playbooksData.map((playbook: any) => ({
      ...playbook,
      selected: false
    }));
    this.playbooksSource=playbooksData
    //GET THE COMPANIES NAMES
        this.listOfPlaybooks.forEach((playbook: Playbook) => {
          if (playbook.company && !this.companies.includes(playbook.company)) {
            this.companies.push(playbook.company);
          }
        });

    // SORT COMPANIES BY NAME
      this.companies.sort((a, b) => (a || '').localeCompare(b || ''));
    //SOTT PLAYBOOKS BY COMPANY
      this.listOfPlaybooks.sort((a, b) => (a.company || '').localeCompare(b.company || ''));
    //GET THE MEMBERS
      this.getMembers();


    //console.log("listOfPlaybooks", this.listOfPlaybooks)
  }

  async getMembers() {
    this.members = await this.apiService.getMembers();
    this.membersSource=this.members;
  }

  searchMember(event: any){
    let value = event.target.value;
    this.members = this.membersSource.filter(member => member.name.toLowerCase().includes(value.toLowerCase()));
  }

  openInviteModal(): void {
    this.showInviteModal = true;
  }

  closeInviteModal(): void {
    this.showInviteModal = false;
    // Reset form values
    this.name = '';
    this.email = '';
    this.job_title = '';
    this.can_edit = false;
    this.can_use_advanced_editor = false;
    this.can_access_crm = false;
    this.can_view_billable_minutes = false;
    this.can_view_recordings = true;
    this.can_manage_tokens = false;
    this.send_email = true;
    this.role = 'member';
    this.playbooks = [];
    // Reset playbooks selection
    this.listOfPlaybooks.forEach(playbook => {
      playbook.selected = false;
    });
  }

  openEditMemberModal(id:string|undefined): void {
    //console.log('listOfPlaybooks length', this.listOfPlaybooks.length)
    this.showEditMemberModal = true;
    this.memberForEdit = this.members.find(member => member.id === id);
    if (this.memberForEdit) {
      this.nameEdit = this.memberForEdit.name;
      this.emailEdit = this.memberForEdit.email;
      this.job_titleEdit = this.memberForEdit.job_title;
      this.can_editEdit = this.memberForEdit.can_edit;
      this.can_use_advanced_editorEdit = this.memberForEdit.can_use_advanced_editor || false;
      this.can_access_crmEdit = this.memberForEdit.can_access_crm || false;
      this.can_view_billable_minutesEdit = this.memberForEdit.can_view_billable_minutes || false;
      this.can_manage_tokensEdit = this.memberForEdit.can_manage_tokens || false;
      this.roleEdit = this.memberForEdit.role === 'admin' ? 'admin' : 'member';
      this.memberForEdit.playbooks = this.memberForEdit.assistants===""?[]:this.memberForEdit.assistants?.split(",");

      this.listOfPlaybooks.forEach(playbook => {
        playbook.selected = this.memberForEdit?.playbooks?.includes(playbook.id);
      });
      this.playbooksEdit = this.memberForEdit.playbooks===undefined?[]:this.memberForEdit.playbooks;
    }
  }

  closeEditMemberModal(): void {
    this.showEditMemberModal = false;
    this.memberForEdit = undefined;
    this.nameEdit = '';
    this.emailEdit = '';
    this.job_titleEdit = '';
    this.can_editEdit = false;
    this.can_use_advanced_editorEdit = false;
    this.can_access_crmEdit = false;
    this.can_manage_tokensEdit = false;
    this.roleEdit = 'member';
    this.playbooksEdit = [];
  }

  isPlaybookIncluded(playbookId: string): any {
    let isIncluded=this.memberForEdit?.playbooks?.includes(playbookId)
    //SI ESTA INCLUIDO AÑADELO AL ARRAY Y SI NO... ELIMINALO
    //isIncluded?this.playbooksEdit.push(playbookId):this.playbooksEdit.splice(this.playbooksEdit.indexOf(playbookId),1)
    return isIncluded;
  }

  onCheckboxChange(playbook: Playbook): void {
    if (playbook.selected) {
      this.playbooks.push(playbook.id);
    } else {
      const index = this.playbooks.indexOf(playbook.id);
      if (index > -1) {
        this.playbooks.splice(index, 1);
      }
    }
  }



  onCheckboxEditChange(playbook: Playbook): void {
    console.log('playbook', playbook)
    if (playbook.selected) {
      this.playbooksEdit.push(playbook.id);
      console.log("playbooksEdit", this.playbooksEdit)
    } else {
      let index = this.playbooksEdit?.indexOf(playbook.id);
          index = index ? index : -1;

      if (index > -1) {
        this.playbooksEdit?.splice(index, 1);
      }
    }
  }

  // Same shape check as the backend (members.js): catches typos like a
  // trailing dot in the domain before Firebase turns them into a generic
  // "Error creating auth user" (ClientFlow #495).
  private isValidEmail(email: string): boolean {
    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test((email || '').trim());
  }

  sendInvite(): void {
    this.txtSendInvite = this.send_email ? 'Sending...' : 'Creating...';
    let member: Member = {
      email: this.email,
      name: this.name,
      job_title: this.job_title,
      role: this.role,
      can_edit: this.can_edit,
      can_use_advanced_editor: this.can_use_advanced_editor,
      can_access_crm: this.can_access_crm,
      can_view_billable_minutes: this.can_view_billable_minutes,
      can_view_recordings: this.can_view_recordings,
      can_manage_tokens: this.can_manage_tokens,
      playbooks: this.playbooks,
      send_email: this.send_email
    }

    if(member.name!=='' && member.email!=='' && !this.isValidEmail(member.email)){
      this.txtSendInvite = 'Send Invite'; // Reset to default
      this.txtNotificationErrorTitle='Invalid email'
      this.txtNotificationErrorMessage='Please check the email address — it does not look valid.'
      this.showNotificationError();
      return;
    }

    if(member.name!=='' && member.email!==''){
        this.apiService.postMember(member)
        .then(async (response) => {
          this.trackingService.trackClick(
            `Añadir member: ${member.email} (agentes asignados: ${member.playbooks?.length || 0}, envía invitación: ${this.send_email})`
          );
          this.getMembers();
          this.txtSendInvite = 'Send Invite'; // Reset to default
          this.closeInviteModal();

          //SHOW NOTIFICATION
          if (response && response.emailSent === false && this.send_email) {
            // Member was created but the invitation email could not be sent.
            this.txtNotificationErrorTitle = 'Member created, email not sent'
            this.txtNotificationErrorMessage = response.emailWarning || 'The member was created but the invitation email could not be sent. Please resend it.'
            this.showNotificationError();
          } else {
            this.txtNotificationSuccessTitle='Successfully created!'
            this.txtNotificationSuccessMessage='Member created successfully'
            this.showNotificationSuccess();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          this.txtSendInvite = 'Send Invite'; // Reset to default

          //SHOW NOTIFICATION
          const serverMessage = error?.response?.data;
          if(serverMessage==='Already exists' || serverMessage==='Member with this email already exists for this company'){
            this.txtNotificationErrorTitle='Already exists!'
            this.txtNotificationErrorMessage='Member not created'
            this.showNotificationError();
          }else if(serverMessage==='Email belongs to an existing account'){
            this.txtNotificationErrorTitle='Email already in use'
            this.txtNotificationErrorMessage='That email already belongs to an existing account.'
            this.showNotificationError();
          }else{
            this.txtNotificationErrorTitle='There was an error'
            this.txtNotificationErrorMessage = (typeof serverMessage === 'string' && serverMessage) ? serverMessage : 'We were unable to create the member.'
            this.showNotificationError();
          }
        });
    }else{
      this.txtSendInvite = 'Send Invite'; // Reset to default
      this.txtNotificationErrorTitle='There was an error'
      this.txtNotificationErrorMessage='Please fill the required fields.'
      this.showNotificationError();
    }
  }

  /**
   * Sync Firebase claims with ClickHouse data for a member
   * Useful when permissions get out of sync
   */
  async syncMemberClaims(member: Member): Promise<void> {
    try {
      // Show confirmation
      if (!confirm(`¿Sincronizar permisos de Firebase para ${member.name} (${member.email})?\n\nEsto actualizará los claims de Firebase con los datos de ClickHouse.`)) {
        return;
      }

      const response = await this.apiService.syncMemberClaims(member.email);
      
      console.log('✅ Claims synced successfully:', response);
      
      // Show success notification
      this.txtNotificationSuccessTitle = 'Claims Synced!';
      this.txtNotificationSuccessMessage = `Firebase claims for ${member.name} have been synchronized successfully.`;
      this.showNotificationSuccess();
      
    } catch (error: any) {
      console.error('❌ Error syncing claims:', error);
      
      // Show error notification
      this.txtNotificationErrorTitle = 'Sync Failed';
      this.txtNotificationErrorMessage = error?.error?.message || 'Failed to sync Firebase claims. Please try again.';
      this.showNotificationError();
    }
  }

  updateMember(){
    this.txtUpdateMember = 'Saving...'

    //SELECTED PLAYBOOKS IDS
      let ids = $("[name='playbooksEdit']:checked").map(function () {
          return this.id;
      }).get();
    //FIND IN LIST OF PLAYBOOKS THIS IDS
      this.playbooksEdit = this.listOfPlaybooks.filter(playbook => ids.includes(playbook.id)).map(playbook => playbook.id);
      this.apiService.putMember({
        id: this.memberForEdit?.id,
        name: this.nameEdit,
        job_title: this.job_titleEdit,
        playbooks: this.playbooksEdit,
        can_edit: this.can_editEdit,
        can_use_advanced_editor: this.can_use_advanced_editorEdit,
        can_access_crm: this.can_access_crmEdit,
        can_view_billable_minutes: this.can_view_billable_minutesEdit,
        can_view_recordings: this.can_view_recordings,
        can_manage_tokens: this.can_manage_tokensEdit,
        company_id: this.memberForEdit?.user_id // Include company_id for admin operations
      }).then(async (response) => {
        this.trackingService.trackClick(
          `Editar member: ${this.memberForEdit?.email || this.memberForEdit?.id} (agentes asignados: ${this.playbooksEdit?.length || 0})`
        );
        this.getMembers()
        this.txtUpdateMember = 'Save changes';
        this.showEditMemberModal = false;

        //SHOW NOTIFICATION
        this.txtNotificationSuccessTitle='Successfully saved!'
        this.txtNotificationSuccessMessage='Member updated successfully'
        this.showNotificationSuccess();
      })
      .catch((error) => {
        console.error('Error:', error);
        this.txtUpdateMember = 'Save changes';
        this.showNotificationError();
      });
  }

  deleteMember(id: string|undefined): void {

    console.log('id', id)
    this.apiService.deleteMember(id, this.buildRoutineActions())
    .then(async (response) => {
      // The server answers 200 with {deleted:false} when the member row went but
      // the Firebase identity could not be removed. Do not claim success there.
      if (!response || response.deleted !== true) {
        this.showDeleteMemberError(response?.message);
        return;
      }

      this.getMembers()

      //SHOW NOTIFICATION
      this.txtNotificationSuccessTitle='Successfully removed!'
      this.txtNotificationSuccessMessage='Member removed successfully'
      this.hideNotificationForRemove();
      this.showNotificationSuccess();
    })
    .catch((error) => {
      console.error('Error:', error);
      // axios rejects every non-2xx: the body is a string on the old 403/500
      // paths and a {deleted:false, message} object on the newer 502/500 ones.
      const serverData = error?.response?.data;
      const serverMessage = typeof serverData === 'string' ? serverData : serverData?.message;
      this.showDeleteMemberError(serverMessage);
    });
  }

  private showDeleteMemberError(serverMessage?: string): void {
    this.getMembers()
    this.hideNotificationForRemove();
    this.txtNotificationErrorTitle='Could not remove member'
    this.txtNotificationErrorMessage = serverMessage || 'The member could not be removed. Please try again.'
    this.showNotificationError();
  }

  showNotificationForRemove(id:string|undefined, name:string ): void {
    this.shownotificationForRemove = true;
    this.txtMemberNameToRemove=name;
    this.memberForRemove = this.members.find(member => member.id === id);
    this.loadRoutinesForRemove(id);
  }

  hideNotificationForRemove(): void {
    this.shownotificationForRemove = false;
    this.txtMemberNameToRemove="";
    this.memberForRemove = undefined;
    this.removeRoutines = null;
    this.removeRoutinesLoading = false;
    this.removeRoutinesUnknown = false;
    this.removeRoutineChoices = {};
  }

  /**
   * Sus rutinas personales, para elegir qué hacer con ellas antes de la baja.
   * Si no se pueden consultar (p. ej. backend anterior) no se bloquea nada:
   * se avisa de que pasarán a la cuenta en pausa, que es lo que hace el
   * backend por defecto.
   */
  private async loadRoutinesForRemove(id: string | undefined): Promise<void> {
    this.removeRoutines = null;
    this.removeRoutineChoices = {};
    this.removeRoutinesUnknown = false;
    if (!id) return;
    this.removeRoutinesLoading = true;
    try {
      const routines = await this.apiService.getMemberRoutines(id);
      if (this.memberForRemove?.id !== id) return; // se cerró o cambió de member mientras cargaba
      this.removeRoutines = routines;
      for (const routine of routines.owned) this.removeRoutineChoices[routine.id] = 'account';
      if (routines.owned.length > 0 && this.removeWorkspaces.length === 0) {
        this.removeWorkspaces = await this.apiService.getWorkspaces().catch(() => []);
      }
    } catch (error) {
      console.error('Could not load the member routines', error);
      if (this.memberForRemove?.id === id) this.removeRoutinesUnknown = true;
    } finally {
      if (this.memberForRemove?.id === id) this.removeRoutinesLoading = false;
    }
  }

  private buildRoutineActions(): MemberRoutineAction[] | undefined {
    if (!this.removeRoutines || this.removeRoutines.owned.length === 0) return undefined;
    return this.removeRoutines.owned.map((routine) => {
      const choice = this.removeRoutineChoices[routine.id] || 'account';
      if (choice === 'delete') return { id: routine.id, action: 'delete' as const };
      if (choice.startsWith('ws:')) return { id: routine.id, action: 'move_workspace' as const, workspace_id: choice.slice(3) };
      return { id: routine.id, action: 'move_account' as const };
    });
  }

  routineNames(routines: Array<{ name: string }>): string {
    return routines.map((routine) => routine.name || 'Untitled routine').join(', ');
  }

    describeRoutineSchedule(preset: string): string {
    switch (preset) {
      case 'every_1h': return 'Every hour';
      case 'every_4h': return 'Every 4 hours';
      case 'every_8h': return 'Every 8 hours';
      case 'weekly': return 'Weekly';
      default: return 'Daily';
    }
  }

  showNotificationSuccess(): void {
    this.shownotificationSuccess = true;
    setTimeout(() => {
      this.shownotificationSuccess = false;
    }, 3000);
  }

  hideNotificationMemberUpdated(): void {
    this.shownotificationSuccess = false;
  }

  showNotificationError(): void {
    this.txtNotificationSuccessMessage='Member updated successfully'
    this.shownotificationError = true;
    setTimeout(() => {
      this.shownotificationError = false;
    }, 3000);
  }

  hideNotificationError(): void {
    this.shownotificationError = false;
  }


  toggleCanEdit() {
   // this.canEdit = !this.canEdit;
    this.can_edit = !this.can_edit;
  }

  toggleCanEditEdit() {
    // this.canEdit = !this.canEdit;
     this.can_editEdit = !this.can_editEdit;
   }

  toggleCanUseAdvancedEditor() {
    this.can_use_advanced_editor = !this.can_use_advanced_editor;
  }

  toggleCanUseAdvancedEditorEdit() {
    this.can_use_advanced_editorEdit = !this.can_use_advanced_editorEdit;
  }

  toggleCanAccessCrm() {
    this.can_access_crm = !this.can_access_crm;
  }

  toggleCanAccessCrmEdit() {
    this.can_access_crmEdit = !this.can_access_crmEdit;
  }

  toggleCanViewBillableMinutes() {
    this.can_view_billable_minutes = !this.can_view_billable_minutes;
  }

  toggleCanViewBillableMinutesEdit() {
    this.can_view_billable_minutesEdit = !this.can_view_billable_minutesEdit;
  }

  filterPlaybooksByCompany() {
    this.companySelected = $("#companies").val() as string;
    if(this.companySelected === "all") {
      this.listOfPlaybooks = this.playbooksSource;
    }else{
      this.listOfPlaybooks=this.playbooksSource
      this.listOfPlaybooks = this.listOfPlaybooks.filter((playbook: Playbook) => playbook.company === this.companySelected);
    }
  }

  isDomain(domain:string ){
    let temp=this.authService.getDomain()
    return temp == domain
  }

  isMeetzyUser(): boolean {
    const userEmail = this.authService.getUserEmail();
    return userEmail ? userEmail.endsWith('@meetzy.io') : false;
  }

  isDarkMode(): boolean {
    return this.appComponent.isDarkMode();
  }

  toggleCanManageTokens() {
    this.can_manage_tokens = !this.can_manage_tokens;
  }

  toggleCanManageTokensEdit() {
    this.can_manage_tokensEdit = !this.can_manage_tokensEdit;
  }

  toggleCanViewRecordings() {
    this.can_view_recordings = !this.can_view_recordings;
  }

  toggleSendEmail() {
    this.send_email = !this.send_email;
  }

  async getUsers() {
    try {
      const response = await this.apiService.get('/dashboard/users');
      this.users = response;
      this.usersSource = response;
      this.applyUserFilters();
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  }

  openChangePasswordModal(member: any): void {
    this.selectedMember = member;
    this.newPassword = '';
    this.showPasswordError = false;
    this.passwordErrorMessage = '';
    this.showChangePasswordModal = true;
  }

  closeChangePasswordModal(): void {
    this.showChangePasswordModal = false;
    this.selectedMember = null;
    this.newPassword = '';
    this.showPasswordError = false;
    this.passwordErrorMessage = '';
  }

  async updateMemberPassword(): Promise<void> {
    if (!this.selectedMember || !this.newPassword) {
      this.showPasswordError = true;
      this.passwordErrorMessage = 'Password is required';
      return;
    }

    if (this.newPassword.length < 6) {
      this.showPasswordError = true;
      this.passwordErrorMessage = 'Password must be at least 6 characters';
      return;
    }

    try {
      await this.apiService.put('/dashboard/member/update-password', {
        email: this.selectedMember.email,
        password: this.newPassword
      });

      this.txtNotificationSuccessTitle = 'Password Updated!';
      this.txtNotificationSuccessMessage = 'Member password has been updated successfully';
      this.showNotificationSuccess();
      this.closeChangePasswordModal();
    } catch (error) {
      console.error('Error updating password:', error);
      this.showPasswordError = true;
      this.passwordErrorMessage = 'Failed to update password. Please try again.';
    }
  }

  // Account roles ------------------------------------------------------

  /** Mirrors the backend rule: only the owner may act on another admin. */
  canActOnMember(member: Member): boolean {
    if (member.role === 'admin' && !this.isOwner) {
      return false;
    }
    return true;
  }

  toggleActionsMenu(id: string | undefined): void {
    this.openActionsMenuId = this.openActionsMenuId === id ? undefined : id;
  }

  closeActionsMenu(): void {
    this.openActionsMenuId = undefined;
  }

  async promoteToAdmin(member: Member): Promise<void> {
    this.closeActionsMenu();
    if (!confirm(`Make ${member.name} an account admin? They'll get full access to every setting, just like you.`)) {
      return;
    }
    try {
      await this.apiService.updateMemberRole(member.id as string, 'admin');
      this.trackingService.trackClick(`Promote to admin: ${member.email}`);
      await this.getMembers();
      this.txtNotificationSuccessTitle = 'Promoted to admin';
      this.txtNotificationSuccessMessage = `${member.name} can now manage the whole account.`;
      this.showNotificationSuccess();
    } catch (error: any) {
      this.txtNotificationErrorTitle = 'Could not promote';
      this.txtNotificationErrorMessage = error?.response?.data || 'Something went wrong while changing this role.';
      this.showNotificationError();
    }
  }

  async demoteToMember(member: Member): Promise<void> {
    this.closeActionsMenu();
    if (!confirm(`Remove admin access from ${member.name}? They'll go back to a regular member with their previous permissions.`)) {
      return;
    }
    try {
      await this.apiService.updateMemberRole(member.id as string, 'member');
      this.trackingService.trackClick(`Demote to member: ${member.email}`);
      await this.getMembers();
      this.txtNotificationSuccessTitle = 'Moved to member';
      this.txtNotificationSuccessMessage = `${member.name} is now a regular member.`;
      this.showNotificationSuccess();
    } catch (error: any) {
      this.txtNotificationErrorTitle = 'Could not update role';
      this.txtNotificationErrorMessage = error?.response?.data || 'Something went wrong while changing this role.';
      this.showNotificationError();
    }
  }

  async resendInvite(member: Member): Promise<void> {
    this.closeActionsMenu();
    this.resendingInviteFor = member.id;
    try {
      await this.apiService.resendMemberInvite(member.email);
      this.txtNotificationSuccessTitle = 'Invitation sent';
      this.txtNotificationSuccessMessage = `A new invitation was sent to ${member.email}.`;
      this.showNotificationSuccess();
    } catch (error: any) {
      this.txtNotificationErrorTitle = 'Could not send invitation';
      this.txtNotificationErrorMessage = error?.response?.data?.error || 'The invitation email could not be sent. Please try again.';
      this.showNotificationError();
    } finally {
      this.resendingInviteFor = undefined;
    }
  }

  openChangeEmailModal(member: Member): void {
    this.closeActionsMenu();
    this.memberForEmailChange = member;
    this.newMemberEmail = '';
    this.emailChangeError = '';
    this.showChangeEmailModal = true;
  }

  closeChangeEmailModal(): void {
    this.showChangeEmailModal = false;
    this.memberForEmailChange = undefined;
    this.newMemberEmail = '';
    this.emailChangeError = '';
  }

  async submitChangeEmail(): Promise<void> {
    if (!this.memberForEmailChange || !this.newMemberEmail) {
      this.emailChangeError = 'Enter the new email address.';
      return;
    }
    this.emailChangeSaving = true;
    this.emailChangeError = '';
    try {
      await this.apiService.updateMemberEmail(this.memberForEmailChange.id as string, this.newMemberEmail);
      this.trackingService.trackClick(`Change member email: ${this.memberForEmailChange.email} -> ${this.newMemberEmail}`);
      await this.getMembers();
      this.closeChangeEmailModal();
      this.txtNotificationSuccessTitle = 'Email updated';
      this.txtNotificationSuccessMessage = 'They\'ll get an email to confirm their new address.';
      this.showNotificationSuccess();
    } catch (error: any) {
      this.emailChangeError = error?.response?.data || 'Could not update this email. It may already be in use.';
    } finally {
      this.emailChangeSaving = false;
    }
  }

  applyUserFilters() {
    let filteredUsers = [...this.usersSource];

    // Apply status filter
    if (this.userStatusFilter !== 'all') {
      filteredUsers = filteredUsers.filter(user => 
        this.userStatusFilter === 'disabled' ? user.disabled : !user.disabled
      );
    }

    // Apply search
    if (this.userSearchQuery) {
      const query = this.userSearchQuery.toLowerCase();
      filteredUsers = filteredUsers.filter(user => 
        (user.fullname && user.fullname.toLowerCase().includes(query)) ||
        (user.email && user.email.toLowerCase().includes(query)) ||
        (user.company && user.company.toLowerCase().includes(query))
      );
    }

    // Apply sorting
    filteredUsers.sort((a, b) => {
      let aValue = a[this.userSortField];
      let bValue = b[this.userSortField];

      // Handle null values
      if (!aValue) aValue = '';
      if (!bValue) bValue = '';

      // Convert to lowercase for string comparison
      if (typeof aValue === 'string') aValue = aValue.toLowerCase();
      if (typeof bValue === 'string') bValue = bValue.toLowerCase();

      if (aValue < bValue) return this.userSortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.userSortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.users = filteredUsers;
  }


}
